// Footer.jsx
import React, { useState, useContext } from "react";
import { Link } from "react-router-dom"; // استيراد Link من React Router
import { ThemeContext } from "../context/ThemeContext";
import logo from "../assets/logo.png";
import logoDark from "../assets/logo_dark.png";

const Footer = () => {
  const { theme } = useContext(ThemeContext);
  const currentYear = new Date().getFullYear();
  const [email, setEmail] = useState("");
  const [subscribed, setSubscribed] = useState(false);

  // روابط الصفحات مع المسارات المناسبة
  const quickLinks = [
    { name: "Home", path: "/", icon: "fa-solid fa-house" },
    { name: "About Us", path: "/about", icon: "fa-solid fa-info-circle" },
    { name: "Services", path: "/services", icon: "fa-solid fa-stethoscope" },
    { name: "Packages", path: "/packages", icon: "fa-solid fa-box" },
    { name: "Portfolio", path: "/portfolio", icon: "fa-solid fa-folder-open" },
    { name: "Contact", path: "/contact", icon: "fa-solid fa-envelope" },
  ];

  const servicesList = [
    "Social Media Marketing",
    "Paid Advertising Campaigns",
    "SEO & Content Marketing",
    "Brand Strategy & Design",
    "Email Marketing",
    "Marketing Analytics",
  ];

  const contactInfo = [
    { icon: "fa-solid fa-location-dot", text: "فلسطين، غزة" },
    { icon: "fa-solid fa-phone", text: "+201037330569" },
    { icon: "fa-solid fa-envelope", text: "codicaix@gmail.com" },
  ];

  const socialLinks = [
    { name: "Facebook", icon: "fa-brands fa-facebook-f", link: "https://www.facebook.com/share/1E4iRwoubt/", color: "#1877f2" },
    { name: "Instagram", icon: "fa-brands fa-instagram", link: "https://www.instagram.com/codi.calix?igsh=MWM5YmJ6Nng0ZDlmMQ==", color: "#e4405f" },
  ];

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (email) {
      setSubscribed(true);
      setEmail("");
      setTimeout(() => setSubscribed(false), 3000);
    }
  };

  return (
    <footer className="footer" style={{ background: "var(--card-bg)", color: "var(--text-color)", transition: "all 0.3s ease" }}>
      <div className="footer-content" style={{ padding: "2rem" }}>
        <div className="footer-top" style={{ display: "flex", flexWrap: "wrap", gap: "2rem" }}>
          
          {/* Logo Section */}
          <div className="footer-section" style={{ flex: "1 1 240px" }}>
            <Link to="/" style={{ textDecoration: "none", display: "flex", alignItems: "center", gap: "0.5rem", marginBottom: "1rem" }}>
            <div className="logo-icon">
  <img src={theme === "dark" ? logoDark : logo} alt="CodiCal X Logo" style={{ width: "40px", height: "40px" }} />
</div>
              <h2 style={{ fontSize: "1.5rem", margin: 0, color: "var(--primary)" }}>CodiCal X</h2>
            </Link>
            <p style={{ fontSize: "0.85rem", color: "var(--text-secondary)", lineHeight: 1.5 }}>
              Transforming businesses through innovative digital marketing solutions.
              We provide cutting-edge marketing strategies and campaigns.
            </p>
          </div>

          {/* Quick Links */}
          <div className="footer-section" style={{ flex: "1 1 150px" }}>
            <h3 style={{ fontWeight: 700, marginBottom: "1rem", color: "var(--primary)" }}>Quick Links</h3>
            <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
              {quickLinks.map((link, index) => (
                <li key={index} style={{ marginBottom: "0.5rem" }}>
                  <Link 
                    to={link.path}
                    style={{ textDecoration: "none", color: "var(--text-secondary)", transition: "color 0.3s" }}
                    onMouseEnter={e => e.target.style.color = "var(--primary)"}
                    onMouseLeave={e => e.target.style.color = "var(--text-secondary)"}
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services - يمكن تحويلها إلى روابط إذا كان لديك صفحات لكل خدمة، حالياً هي مجرد نص */}
          <div className="footer-section" style={{ flex: "1 1 150px" }}>
            <h3 style={{ fontWeight: 700, marginBottom: "1rem", color: "var(--primary)" }}>Our Services</h3>
            <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
              {servicesList.map((service, index) => (
                <li key={index} style={{ marginBottom: "0.5rem", color: "var(--text-secondary)" }}>{service}</li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-section" style={{ flex: "1 1 200px" }}>
            <h3 style={{ fontWeight: 700, marginBottom: "1rem", color: "var(--primary)" }}>Contact Info</h3>
            <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
              {contactInfo.map((info, index) => (
                <li key={index} style={{ marginBottom: "0.5rem", color: "var(--text-secondary)" }}>{info.text}</li>
              ))}
            </ul>

            {/* Newsletter */}
            <form onSubmit={handleSubscribe} style={{ marginTop: "1rem", display: "flex", gap: "0.5rem" }}>
              <input
                type="email"
                placeholder="Your Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                style={{ 
                  flex: 1, 
                  padding: "0.5rem", 
                  border: "1px solid var(--border-color)", 
                  borderRadius: "4px",
                  background: "var(--bg-color)",
                  color: "var(--text-color)"
                }}
              />
              <button 
                type="submit" 
                style={{ 
                  padding: "0.5rem 1rem", 
                  backgroundColor: "var(--primary)", 
                  color: "#fff", 
                  border: "none", 
                  cursor: "pointer", 
                  borderRadius: "4px",
                  transition: "background 0.3s"
                }}
                onMouseEnter={e => e.target.style.backgroundColor = "var(--primary-dark)"}
                onMouseLeave={e => e.target.style.backgroundColor = "var(--primary)"}
              >
                Subscribe
              </button>
            </form>
            {subscribed && <div style={{ marginTop: "0.5rem", color: "var(--primary)" }}>Subscribed!</div>}
          </div>
        </div>

        {/* Social Links */}
        <div className="footer-social" style={{ marginTop: "2rem", display: "flex", gap: "1rem" }}>
          {socialLinks.map((social, index) => (
            <a
              key={index}
              href={social.link}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "38px",
                height: "38px",
                backgroundColor: social.color,
                color: "#fff",
                borderRadius: "50%",
                textDecoration: "none",
                transition: "opacity 0.3s"
              }}
              onMouseEnter={e => e.target.style.opacity = "0.8"}
              onMouseLeave={e => e.target.style.opacity = "1"}
            >
              <i className={social.icon}></i>
            </a>
          ))}
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom" style={{ marginTop: "2rem", textAlign: "center", fontSize: "0.8rem", color: "var(--text-secondary)" }}>
          © {currentYear} CodiCal X. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;